import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useMedia } from 'use-media'

import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { Text, mediaQueries, Icon } from '@redriverpress/system'
import {
  RichButton,
  RichDropdownButton,
  RichDropdownOptionsWrapper,
  RichDropdownOption,
} from './RichTextareaComponents'

export default function FontFamilySelector({ editor }) {
  const isMd = useMedia(mediaQueries.md)
  const [dropDownIsOpen, setDropdownIsOpen] = useState(false)
  const [currentFontOption, setCurrentFontOption] = useState(0)
  const [selectedFont, setSelectedFont] = useState('Open Sans')

  const fontOptions = [
    {
      label: 'Comic Neue',
      clickEvent: () => {
        setSelectedFont('Comic Neue')
        editor
          .chain()
          .focus()
          .setFontFamily('Comic Neue')
          .run()
      },
    },
    {
      label: 'Noto Serif',
      clickEvent: () => {
        setSelectedFont('Noto Serif')
        editor
          .chain()
          .focus()
          .setFontFamily('Noto Serif')
          .run()
      },
    },
    {
      label: 'Open Sans',
      clickEvent: () => {
        setSelectedFont('Open Sans')
        editor
          .chain()
          .focus()
          .setFontFamily('Open Sans')
          .run()
      },
    },
  ]

  const MAX_INDEX = fontOptions.length - 1

  // This method is sequentially switching the options listed in the fontOptions.
  // That's because on mobile breakpoint, we needed to replace the dropdown
  // by a switch button, so that it solved some scrolling issues.
  const switchFont = () => {
    const nextFontOption =
      currentFontOption === MAX_INDEX ? 0 : currentFontOption + 1
    setCurrentFontOption(nextFontOption)
    fontOptions[nextFontOption].clickEvent()
  }

  useEffect(() => {
    editor.on('selectionUpdate', () => {
      const pointedText = editor.getAttributes('textStyle').fontFamily
      !!pointedText && setSelectedFont(pointedText)
    })

    return () => {
      editor.off('selectionUpdate')
    }
  }, [editor])

  return isMd ? (
    <DropdownMenu.Root onOpenChange={o => setDropdownIsOpen(o)}>
      <DropdownMenu.Trigger asChild>
        <RichDropdownButton
          mr={1}
          width={['auto', null, null, '100px', '108px']}
          small
          secondary
        >
          <Text flex='1' mr={2} as='span'>
            {selectedFont}
          </Text>
          <Icon icon={dropDownIsOpen ? 'chevron-up' : 'chevron-down'} />
        </RichDropdownButton>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content asChild>
        <RichDropdownOptionsWrapper>
          {fontOptions.map(fontOption => (
            <RichDropdownOption
              onClick={() => {
                fontOption.clickEvent()
              }}
              key={fontOption.label}
            >
              {fontOption.label}
            </RichDropdownOption>
          ))}
        </RichDropdownOptionsWrapper>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  ) : (
    <RichButton
      mr={1}
      onClick={() => {
        switchFont()
      }}
      minWidth='90px'
      small
      secondary
    >
      <Text>{selectedFont}</Text>
    </RichButton>
  )
}

FontFamilySelector.defaultProps = {
  editor: null,
}

FontFamilySelector.propTypes = {
  editor: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.bool])
  ),
}
